<template>
    <div class="complaint-summary">
        <div class="content">
            <div class="section-container">
                <div class="section-header">
                    <div class="section-title">投诉</div>
                    <div class="section-line"></div>
                </div>
                <div class="item-grid">
                    <div class="item-card" v-for="(item, index) in complaintItems" :key="index"
                        @click="navigateTo('投诉', item.name)">
                        <div class="item-icon-container">
                            <van-image class="item-icon" :src="item.src"></van-image>
                        </div>
                        <div class="item-name">{{ item.name }}</div>
                    </div>
                </div>
            </div>

            <div class="section-container">
                <div class="section-header">
                    <div class="section-title">建议</div>
                    <div class="section-line"></div>
                </div>
                <div class="item-grid">
                    <div class="item-card" v-for="(item, index) in suggestionItems" :key="index"
                        @click="navigateTo('建议', item.name)">
                        <div class="item-icon-container">
                            <van-image class="item-icon" :src="item.src"></van-image>
                        </div>
                        <div class="item-name">{{ item.name }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ComplaintSummary",
    data() {
        return {
            complaintItems: [
                { name: '河道', type: 'river', src: require('@/assets/icon/complaint/river.png') },
                { name: '湖泊', type: 'lake', src: require('@/assets/icon/complaint/lake.png') },
                { name: '海湾', type: 'bay', src: require('@/assets/icon/complaint/bay.png') }
            ],
            suggestionItems: [
                { name: '河道', type: 'river', src: require('@/assets/icon/complaint/river.png') },
                { name: '湖泊', type: 'lake', src: require('@/assets/icon/complaint/lake.png') },
                { name: '海湾', type: 'bay', src: require('@/assets/icon/complaint/bay.png') }
            ]
        };
    },
    methods: {
        navigateTo(type, value) {
            localStorage.setItem('riverSelectedName', '');
            this.$router.push({ path: `/complaint/${type}/${value}` });
        }
    }
};
</script>

<style scoped>
.complaint-summary {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background: url("@/assets/img/complaint-bg.png") no-repeat;
    background-size: cover;
    background-position: center;
    padding: 20px 0;
}

.content {
    width: 90%;
    max-width: 500px;
    padding: 15px;
}

.section-container {
    background: rgba(0, 0, 0, 0.7);
    border-radius: 12px;
    padding: 15px;
    margin-bottom: 20px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(5px);
}

.section-header {
    margin-bottom: 15px;
    position: relative;
}

.section-title {
    color: #ffffff;
    font-size: 20px;
    font-weight: 600;
    padding-left: 15px;
    position: relative;
}

.section-title::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 5px;
    height: 20px;
    background: linear-gradient(to bottom, #0081ff, #1cbbb4);
    border-radius: 3px;
}

.section-line {
    height: 1px;
    background: rgba(255, 255, 255, 0.2);
    margin-top: 10px;
}

.item-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    margin-top: 10px;
}

.item-card {
    width: 30%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 15px;
    transition: all 0.3s ease;
}

.item-card:active {
    transform: scale(0.95);
}

.item-icon-container {
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.2);
    transition: all 0.3s ease;
}

.item-card:hover .item-icon-container {
    background: rgba(255, 255, 255, 0.25);
    transform: translateY(-3px);
}

.item-icon {
    width: 65%;
    height: 65%;
}

.item-name {
    color: #ffffff;
    font-size: 16px;
    margin-top: 5px;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

@media (max-width: 320px) {
    .item-icon-container {
        width: 50px;
        height: 50px;
    }

    .item-name {
        font-size: 14px;
    }

    .section-title {
        font-size: 18px;
    }
}
</style>